import { render, staticRenderFns } from "./FHAMaterials.vue?vue&type=template&id=61b30311&"
import script from "./FHAMaterials.vue?vue&type=script&lang=js&"
export * from "./FHAMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports